var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ice-print" },
    [
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.tipTxt) },
        on: { click: _vm.tipClick },
      }),
      _c(
        "el-button-group",
        [
          _c(
            "el-button",
            _vm._b(
              {
                attrs: {
                  size: "small",
                  type: "primary",
                  icon: "el-icon-printer",
                },
                on: { click: _vm.goPrint },
              },
              "el-button",
              _vm.$attrs,
              false
            ),
            [_vm._v(_vm._s(_vm.print.name))]
          ),
        ],
        1
      ),
      _c("div", {
        style: _vm.showGrid ? "" : "display: none",
        attrs: { id: "report_holder" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }